// @flow
import React from "react";
import type { Node } from "react";
import styled from "styled-components";
import { media } from "@nested/ui";
import Swoosh from "./Swoosh";

const TopSwoosh = styled.div`
  width: 100%;
  background-color: ${({ background = "transparent" }) => background};
  padding-top: ${({ isSwooshVisible }) => isSwooshVisible && "25px"};

  ${media.tablet`
    padding-top: ${({ isSwooshVisible }) => isSwooshVisible && "50px"};
  `};
`;

const BottomSwoosh = styled.div`
  width: 100%;
  padding-bottom: ${({ isSwooshVisible }) => isSwooshVisible && "25px"};

  ${media.tablet`
    padding-bottom: ${({ isSwooshVisible }) => isSwooshVisible && "50px"};
  `};
`;

const Div = styled.div`
  position: relative;
`;

type Props = {
  children: Node,
  colour: string,
  shade?: string,
  swoosh: string,
  previousBackgroundColour?: string,
};

export default function SwooshWrapper({
  children,
  colour,
  shade = "extraLight",
  swoosh,
  previousBackgroundColour,
}: Props) {
  return (
    <Div>
      {swoosh.includes("Top") && (
        <TopSwoosh
          background={previousBackgroundColour}
          isSwooshVisible={swoosh.includes("Top")}
        >
          <Swoosh colour={colour} shade={shade} position="top" />
        </TopSwoosh>
      )}
      {children}
      {swoosh.includes("Bottom") && (
        <BottomSwoosh isSwooshVisible={swoosh.includes("Bottom")}>
          <Swoosh colour={colour} shade={shade} position="bottom" />
        </BottomSwoosh>
      )}
    </Div>
  );
}
